import AddIcon from '@mui/icons-material/Add';
import { IconButton, Grid, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { getCrmJobStatusList, saveCrmJobStatus, CrmJobStatusDTO } from 'wisestep-api';
import { WsButton, WsDataGrid } from 'wisestep-base';

import { SettingsPageLayout } from '../../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';

import CrmJobStatusForm from './CrmJobStatusForm';

const CrmJobStatus = () => {
  const [crmJobStatusList, setCrmJobStatusList] = useState<CrmJobStatusDTO[]>([]);
  const [flag, setFlag] = useState<boolean>(false);
  const [dialogDefaultValues, setDialogDefaultValues] = useState<CrmJobStatusDTO | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  const fetchAll = async () => {
    const response = await getCrmJobStatusList();
    setCrmJobStatusList(response.data ?? []);
  };

  useEffect(() => {
    fetchAll();
  }, [flag]);

  const onSave = () => {
    setOpen(false);
    setFlag(true);
    fetchAll();
  };

  const openStatusFormDialog = (defaultValues?: CrmJobStatusDTO) => {
    setDialogDefaultValues(defaultValues || null);
    setOpen(true);
  };

  const columns: GridColDef[] = [
    {
      field: 'statusName',
      headerName: 'CRM Job Status',
      flex: 1,
    },
    {
      field: 'visibility',
      headerName: 'Visibility',
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Switch
            readOnly
            defaultChecked={row.visibility}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              saveCrmJobStatus({ ...row, visibility: event.target.checked }).then(fetchAll);
            }}
          />
        );
      },
    },
    {
      field: 'isDefaultStatus',
      headerName: 'Is Default Status',
      width: 150,
      renderCell: (params) => (params.row.isDefaultStatus ? 'Yes' : 'No'),
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      flex: 1,
    },
    {
      field: 'edit',
      headerName: '',
      width: 80,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;
        return (
          <IconButton onClick={() => openStatusFormDialog(row)}>
            <FaRegEdit />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <SettingsPageLayout
        title="CRM Job Status"
        indexOptions={[{ label: 'CRM Job Status', url: '/crm-job-status' }]}
        breadCrumnbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.CRM_JOBS,
          Pages['CRM_JOBS_STATUS']
        )}
      >
        <Grid container p={2} justifyContent="flex-end" alignItems="center">
          <Grid item>
            <WsButton
              startIcon={<AddIcon />}
              variant="outlined"
              onClick={() => openStatusFormDialog()}
            >
              Add CRM Job Status
            </WsButton>
          </Grid>
        </Grid>
        <Grid p={2}>
          <WsDataGrid
            columns={columns}
            rows={crmJobStatusList.map((item, index) => ({ ...item, id: index }))}
            autoHeight
          />
        </Grid>
      </SettingsPageLayout>
      {open && (
        <CrmJobStatusForm
          open={open}
          onSave={onSave}
          onCancel={() => setOpen(false)}
          crmJobStatusList={crmJobStatusList}
          {...(dialogDefaultValues && { defaultValues: dialogDefaultValues })}
        />
      )}
    </>
  );
};

export default CrmJobStatus;
